import {LatLngLiteral, PathOptions} from "leaflet";

const zoom = 10.5;
const zoomSnap = .5;
const zoomDelta = .5;
const maxZoom = 16;
const scrollWheelZoom = false;

const initialCenter: LatLngLiteral = {
    lat: 50.27834545,
    lng: 18.88214611435756
};


const style: PathOptions = {
    color: '#fff',
    opacity: 1,
    weight: 0.8,
    lineCap: 'round',
    lineJoin: 'round',
    dashArray: '3',
    fillColor: 'rgb(224, 236, 244)',
    fillOpacity: 0.9,
    fillRule: 'evenodd',
};

const defaultColor = '#dee2e6';
const fillColors = [
    '#9ecae1',
    '#2171b5',
    '#08306b',
];

const colorGrades = [0, .5, .8];

const featureStyle = {
    normal: {
        'color': '#fff',
        weight: .8,
        className: '',
    },
    mouseOver: {
        'color': 'yellow',
        weight: 5,
    },
    mouseOut: {
        'color': '#fff',
        weight: .8
    },
    clicked: {
        color: 'yellow',
        weight: 5,
        className: 'clicked',
    }
}

export {
    zoom,
    zoomSnap,
    zoomDelta,
    maxZoom,
    scrollWheelZoom,
    style,
    fillColors,
    colorGrades,
    initialCenter,
    defaultColor,
    featureStyle
}